import React, { Component, Fragment } from 'react'
import ReactGA from 'react-ga'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { Box, Dropdown, SwxTheme, Typography } from 'swx-atomic-component-lib'
import QuestionIcon from 'calcite-ui-icons-react/QuestionIcon'
import UsersIcon from 'calcite-ui-icons-react/UsersIcon'
import UserIcon from 'calcite-ui-icons-react/UserIcon'
import LockIcon from 'calcite-ui-icons-react/LockIcon'
import OrganizationIcon from 'calcite-ui-icons-react/OrganizationIcon'
import styles from './styles'
import i18n from '../i18n'

const { x4, getX } = SwxTheme.sizing
class OverflowMenu extends Component {
  constructor (props) {
    super(props)
    this.items = [
      { label: i18n.menu.help, value: 'helpAndSupport', to: 'https://help.smarterwx.com.au/', icon: <QuestionIcon size={15} style={{ marginRight: 25, marginLeft: 15 }} />, verifyVisibility: true },
      { label: i18n.menu.profile, value: 'myProfile', to: '/profile', icon: <UserIcon size={15} style={{ marginRight: 25, marginLeft: 15 }} />, verifyVisibility: true },
      // { label: 'My account', value: 'myAccount', to: '/account', icon: <UserIcon size={15} style={{marginRight: 25, marginLeft: 15}} />, verifyVisibility: true },
      {
        label: i18n.menu.enterprise,
        value: 'myEnterprise',
        to: '/enterprise',
        icon: <OrganizationIcon size={15} style={{ marginRight: 25, marginLeft: 15 }} />,
        verifyVisibility: !!(this.props.user && this.props.user.is_enterprise_administrator)
      },
      // { label: 'Change password', value: 'changePassword', to: '/security', icon: <KeyIcon size={15} style={{marginRight: 25, marginLeft: 15}} />, verifyVisibility: true },
      {
        label: i18n.menu.impersonate,
        value: 'impersonateUser',
        to: '/impersonateUser',
        icon: <UsersIcon size={15} style={{ marginRight: 25, marginLeft: 15 }} />,
        verifyVisibility: !!(this.props.user && this.props.user.role === 'SYSADMIN')
      },
      { label: i18n.menu.logout, value: 'signOut', to: '/logout', icon: <LockIcon size={15} style={{ marginRight: 25, marginLeft: 15 }} />, verifyVisibility: true }
    ]
    this.handleGoTo = this.handleGoTo.bind(this)
  }

  handleGoTo ({ value, to }) {
    ReactGA.event({ category: 'Menu', action: value })
    if (value !== 'helpAndSupport') {
      this.props.history.push(to)
    } else if (value === 'helpAndSupport') {
      window.open(to)
    }
  }

  logout () {
    window.sessionStorage.removeItem('locate-auth-token')
    window.location.href = '/'
  }

  render () {
    const { user } = this.props
    let { isGetAvatarSuccess } = this.props
    let isAvatarDeleted = false

    if (!isGetAvatarSuccess) {
      isAvatarDeleted = true
    }

    if (this.props.self) {
      if (this.props.self.avatarDeleted) {
        isAvatarDeleted = true
        isGetAvatarSuccess = false
      } else if (this.props.self.avatarUpdated) {
        isGetAvatarSuccess = true
        isAvatarDeleted = false
      }
    }

    const items = this.items
    return (
      <Dropdown
        type='overflow'
        itemListProps={{ customStyle: styles.itemsPropsCustomStyle }}
        onChange={this.handleGoTo}
        customStyle={styles.dropdown}
      >
        {({ getItemProps, getToggleButtonProps, isOpen }) => {
          return (
            <>
              <Box customStyle={styles.triggerPoint} {...getToggleButtonProps()}>
                {
                  !isAvatarDeleted && isGetAvatarSuccess &&
                    <Box renderAs='img' borderRadius='50%' w={24} h={24} src={`${process.env.REACT_APP_IDENTITY_API_HOST}/v1/users/me/avatar?${new Date().getTime()}`} />
                }
                {
                  isAvatarDeleted && !isGetAvatarSuccess && (
                    <Box
                      alt='Avatar Image'
                      customStyle={{
                        backgroundColor: '#3879c0',
                        width: 24,
                        height: 24,
                        color: '#FFFFFF',
                        fontSize: '13px',
                        textShadow: '0px 1px 1px rgba(0,0,0,0.4)',
                        fontWeight: 400,
                        borderRadius: '50%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                      }}
                    >
                      {
                        `${user.first_name ? user.first_name.charAt(0) : user.email.charAt(0)}`
                      }
                    </Box>
                  )
                }
              </Box>
              {isOpen && (
                <Box customStyle={styles.overflowWrapper}>
                  {items.map((item, index) =>
                    (
                      item.verifyVisibility &&
                      (
                        <Box
                          key={index}
                          h={x4}
                          w={getX(26)}
                          mb={index === items.length ? x4 : 0}
                          display='flex'
                          justifyContent='flex-end'
                          alignItems='center'
                          customStyle={styles.menuItem}
                          {...getItemProps({ key: index, index, item })}
                        >
                          <Typography className='item-label'>{item.label}</Typography>
                          {item.icon}
                        </Box>
                      )
                    ))}
                </Box>
              )}
            </>
          )
        }}
      </Dropdown>
    )
  }
}

function mapStateToProps (state) {
  return {
    self: state.self
  }
}

export default withRouter(connect(mapStateToProps, {})(OverflowMenu))
